import type {
  Acceptance_Bool_Exp,
  GetAcceptanceCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAcceptanceCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type AcceptanceCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path. Empty/absent ⇒
  // no entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Acceptance_Bool_Exp;
};

export const useGetAcceptanceCount = createQueryHook<
  AcceptanceCountArgs,
  number,
  GetAcceptanceCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.acceptance.acceptanceCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    acceptance_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetAcceptanceCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
